import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AudioDetectionServiceTsService {

	private audioContext: AudioContext | null = null;
	private analyser: AnalyserNode | null = null;
	private interval: any = null;
	private rawStream: MediaStream | null = null;
	private energySubject = new Subject<number>();
	energy$ = this.energySubject.asObservable();

	constructor(private ngZone: NgZone) {}

	async start(stream: MediaStream): Promise<void> {
		this.stop();
		try {
			let analysisStream = stream;
			try {
				this.rawStream = await navigator.mediaDevices.getUserMedia({
					audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false }
				});
				analysisStream = this.rawStream;
			} catch {
				console.warn('[Audio] Raw stream failed, using WebRTC stream');
			}

			this.audioContext = new AudioContext();
			if (this.audioContext.state === 'suspended') {
				await this.audioContext.resume();
			}

			const source = this.audioContext.createMediaStreamSource(analysisStream);
			this.analyser = this.audioContext.createAnalyser();
			this.analyser.fftSize = 2048;
			source.connect(this.analyser);

			this.ngZone.runOutsideAngular(() => {
				this.interval = setInterval(() => this.emitEnergy(), 500);
			});
		} catch (err) {
			console.warn('[Audio] Failed to start:', err);
		}
	}

	stop(): void {
		clearInterval(this.interval);
		this.audioContext?.close();
		this.rawStream?.getTracks().forEach(t => t.stop());
		this.analyser = null;
		this.audioContext = null;
	}

	private emitEnergy(): void {
		if (!this.analyser || !this.audioContext) return;

		const freqData = new Float32Array(this.analyser.frequencyBinCount);
		this.analyser.getFloatFrequencyData(freqData);

		const binHz = this.audioContext.sampleRate / this.analyser.fftSize;
		const low = Math.floor(300 / binHz);
		const high = Math.ceil(3400 / binHz);

		let energy = 0;
		let count = 0;
		for (let i = low; i <= high && i < freqData.length; i++) {
			if (isFinite(freqData[i])) {
				energy += Math.pow(10, freqData[i] / 20); 
				count++;
			}
		}

		this.ngZone.run(() => {
			this.energySubject.next(count > 0 ? energy / count : 0);
		});
	}
}
